import api from "../Component/axios";

export const useVariedad = () => {
  const token = localStorage.getItem("@Token");
  const getVariedades = async (id_cultivo) => {
    try {
      const response = await api.get(
        `api/cultivo/variedad/?id_cultivo=${id_cultivo}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  return { getVariedades };
};
